import React from 'react';
import PropTypes from 'prop-types';
import { getSortedTemplateVersions, isTemplateSelected, shouldShowDeleteIcon, stopEventPropagation } from '../utils/templateUtils';
import trashIcon from '../../../../assets/images/trash-icon.svg';

/**
 * Component for rendering the list of template versions
 */
const TemplateVersionList = ({
  projectTemplateGroup,
  selectedProjectTemplate,
  hoveredOver,
  onTemplateSelected,
  onDeleteVersion,
}) => {
  const sortedVersions = getSortedTemplateVersions(projectTemplateGroup);

  return (
    <React.Fragment>
      {sortedVersions.map(template => {
        const isSelected = isTemplateSelected(template, selectedProjectTemplate);
        const showDelete = shouldShowDeleteIcon(template, projectTemplateGroup, hoveredOver);

        return (
          <div 
            id={'project-template-nav-' + template.id}
            key={template.id} 
            className={`version ${isSelected ? 'selected' : ''}`} 
            onClick={(e) => onTemplateSelected(e, template)}
          >
            <div 
              className="name" 
              onClick={(e) => onTemplateSelected(e, template)}
            >
              Version {template.version}
            </div>
          </div>
        );
      })}
    </React.Fragment>
  );
};

TemplateVersionList.propTypes = {
  projectTemplateGroup: PropTypes.array.isRequired,
  selectedProjectTemplate: PropTypes.object,
  hoveredOver: PropTypes.bool.isRequired,
  onTemplateSelected: PropTypes.func.isRequired,
  onDeleteVersion: PropTypes.func.isRequired,
  project_template_id: PropTypes.number,
};

export default TemplateVersionList;



// WEBPACK FOOTER //
// ./src/containers/ProjectTypesContainer/ProjectTemplateCard/components/TemplateVersionList.js